import { Component, EventEmitter, Input, Output } from '@angular/core'
import { formatDisplayHoursToMinutes, formatHours } from '@app/shared/utils/utils'

import { Role } from '@app/features/scoping/models/role.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeElementsService } from '../services/scope-elements.service'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { plainToInstance } from 'class-transformer'
import { TableColumnKey } from '@app/shared/components/ui-components/scope-ui-table/table-column-key.enum'
import { Privilege } from '@app/core/model/enums/privilege.enum'

@Component({
  selector: 'scope-roles-row',
  templateUrl: './roles-row.component.html',
  styleUrls: ['./roles-row.component.scss'],
})
export class RolesRowComponent {
  @Input() level: number
  @Input() role: Role
  @Input() config: ScopeElementsConfig
  @Input() component: ScopeComponent

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  constructor(protected scopeElementsService: ScopeElementsService) {}

  overrideRateCardRoleHours() {
    return () => this.onOverrideRateCardRoleHours.emit({ component: this.component, role: this.role })
  }

  updateRoleHours(rateCardMinutes: number) {
    const role = plainToInstance(Role, { ...this.role, rateCardMinutes })
    this.onUpdateRole.emit({ component: this.component, role })
  }

  formatDisplayValue = (val) => formatHours(val / 60)
  parseDisplayValue = (val) => formatDisplayHoursToMinutes(val)

  protected readonly TableColumnKey = TableColumnKey
  protected readonly Privilege = Privilege
}
